import { KEY_REDUCER_SW } from "@/shared/store/sw/constants";

export const selectorIsSWInit = (state) => state[KEY_REDUCER_SW].isSWInit;